import React, { useState, useContext } from "react";
import Modal from "../../Global/Modal";
import './OkButtonPopUp.scss';
import Button from "../Button";
import PropTypes from 'prop-types';

const OkButtonPopUp = ({ onClick, Content,Contentother }) => {
    console.log("onclick", onClick)
    return (
        <>
            <Modal >
                <div className="okButton-pop-up">
                    <div className="sr-pop-up-description">
                        <p>
                            {Content}
                        </p>
                        <p>
                            {Contentother}
                        </p>

                    </div>
                    <div className="sr-pop-up-proceed">
                        <Button className="okbutton-submit" onClick={onClick}>OK</Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

OkButtonPopUp.propTypes = {
    Content: PropTypes.string,
    Contentother: PropTypes.string,
    onClick: PropTypes.func
}

export default OkButtonPopUp